<template>
  <div class="page sottocategoria-vino-lieviti-saccharomyces">
    <ListingList
      :indexes="indexes"
      :defaultFacetsFilters="defaultFacetsFilters"
      :filter="filter"
      :pageHandle="vinoPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="currentSubCategory.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="vinoPage.sezioneIntroProdotti[0].portrait"
      :hideSidebar="true"
    />
    <ListingIntro
      :introSection="currentSubCategory.sezioneIntroProdotti[0]"
      class="hide-for-large"
    />
    <PagesVinoBirraPreFooterSection
      :preFooterSection="currentSubCategory.sezionePreFooter[0]"
    />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import queries from '@/graphql/craft/queries/index.js'
import { parseQueryFacets } from '~/assets/js/utils/algolia.js'
import {
  useVinoData,
  generateVinoDefaultFacetsFilters,
} from '~/composables/vino-data.js'
import { useHelpers } from '~/composables/helpers.js'

const route = useRoute()
const indexes = ['section_vino']
const filter = route.query?.filter ? parseQueryFacets(route.query?.filter) : []

const { configuration } = useStore()

const query = queries.vinoPage.getVinoPage
const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)
if (!data.value.vinoPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}

const { categories, subcategories } = useVinoData(data)

const currentCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.slug === route.params.slug,
    ) || {}
  )
})

const currentSubCategory = computed(() => {
  return (
    data.value.categories.find(
      (category) => category.key === 'lieviti-non-saccharomyces',
    ) || {}
  )
})

const isValidCategory = computed(() => {
  return (
    currentCategory.value.key === 'lieviti' &&
    currentSubCategory.value.key === 'lieviti-non-saccharomyces'
  )
})

if (!isValidCategory.value) {
  throw createError({ statusCode: 404 })
}
const defaultFacetsFilters = computed(() => {
  const defaultFacets = generateVinoDefaultFacetsFilters(currentCategory)

  return [
    ...defaultFacets,
    ['Filtro_Tipologia_Prodotto_Vino: Lieviti non Saccharomyces'],
  ]
})

const seo = computed(() => currentSubCategory.value.seo || {})

const localeParams = computed(() => currentCategory.value.localized || [])

useSeo({
  ...seo.value,
  localeParams: useHelpers().generateSeoLocaleParams(localeParams, 'slug'),
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})

const vinoPage = computed(() => data.value.vinoPageEntries?.[0])
</script>
